import { Flex, Typography } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { useEvaluationPercentage } from "@/hooks/useEvaluationPercentage/useEvaluationPercentage";

import { Average } from "@/components/Average/Average";

import { EvaluationPercentageProps } from ".";

export function EvaluationPercentage({
  points,
  maximumPoints,
  disabled,
}: EvaluationPercentageProps) {
  const { t } = useTranslation();

  const { percentage } = useEvaluationPercentage({
    points: points ?? 0,
    maximumPoints,
  });

  if (disabled) {
    return (
      <Typography variant="bodySemiboldM" color="text-placeholder">
        {t("not_applicable_full")}
      </Typography>
    );
  }

  // 0 is a valid value.
  if (points === undefined) {
    return;
  }

  if (points === null) {
    return <Average value={points} borderless />;
  }

  return (
    <Flex flexDirection="column" alignItems="flex-end" gap="xxxs">
      <Average value={percentage} borderless />
      <Typography variant="supportingRegularXS" color="text-secondary">
        {t("evaluation.question_summary_points", {
          text: `${points} / ${maximumPoints}`,
        })}
      </Typography>
    </Flex>
  );
}
